import React, { useCallback, useRef, useState } from 'react';
import { Bubble } from 'tea-component';
import { resolveFilterHoverTipVisibility } from './resolveFilterHoverTipVisibility';

interface IFilterHoverTipProps {
  hoverTip: React.ReactNode;
  children: React.ReactNode;
}

const FilterHoverTip: React.FC<IFilterHoverTipProps> = ({ hoverTip, children }) => {
  const wrapperRef = useRef<HTMLSpanElement>(null);
  const [visible, setVisible] = useState(false);

  const syncVisibility = useCallback((target: EventTarget | null) => {
    const wrapper = wrapperRef.current;
    if (!wrapper) {
      setVisible(false);
      return;
    }
    setVisible(resolveFilterHoverTipVisibility(target, wrapper));
  }, []);

  const handleMouseMove = useCallback(
    (event: React.MouseEvent<HTMLSpanElement>) => {
      syncVisibility(event.target);
    },
    [syncVisibility],
  );

  const handleMouseLeave = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <Bubble dark visible={visible} content={hoverTip} placement="top">
      <span
        ref={wrapperRef}
        className="dbi-filter-hover-tip"
        style={{ display: 'inline-flex' }}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </span>
    </Bubble>
  );
};

export default FilterHoverTip;
